import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getTeam() {
  try {
    const data = await axiosInstance({
      url: "/team",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLoginToken()}`,
      },
    });

    return data?.data?.data;
  } catch (error: any) {
    throw new Error(error);
  }
}

const createTeam = async (formData: any) => {
  const data = await axiosInstance({
    url: "/team",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const updateTeam = async (formData: any) => {
  const data = await axiosInstance({
    url: `/team/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteTeam = async (formData: any) => {
  const data = await axiosInstance({
    url: `/team/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useTeam() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.team],
    queryFn: () => getTeam(),
  });
  return data;
}

export function useCreateTeam() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createTeam(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.team]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateTeam() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateTeam(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.team]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteTeam() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteTeam(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.team]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

async function getTrans() {
  try {
    const data = await axiosInstance({
      url: "/transaction",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLoginToken()}`,
      },
    });

    return data?.data?.data;
  } catch (error: any) {
    throw new Error(error);
  }
}

export function useTransaction() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.transaction],
    queryFn: () => getTrans(),
  });
  return data;
}
